<template>
	<div class="not-found">
		<h1>找不到页面</h1>
		<span>{{path}}</span>
	</div>
</template>

<script>
	export default {
		name: "not-found",
		props: {
			path: {},
		},
	}
</script>

<style lang="scss">
	.not-found {
		padding: 16px;
	}
</style>
